import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Registration from './components/Registration';
import TermsAndConditions from './components/TermsAndConditions';
import Program from './components/Program';
//import Activities from './components/Activities';
//import FAQ from './components/FAQ';
import Contact from './components/Contact';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import WhatsAppQR from './components/WhatsAppQR';
import './index.css';
import { Analytics } from '@vercel/analytics/next';

// Home page component
const HomePage: React.FC = () => {
  return (
    <>
      <Navigation />
      {/*
      Firebase Connection Test - Remove this in production
      <div className="pt-20 pb-8 bg-gray-50">
        <FirebaseConnectionTest />
      </div>
      */}
      <main>
        <section id="hero">
          <Hero />
        </section>
        <section id="program">
          <Program />
        </section>
        <section id="registration">
          <Registration />
        </section>
        {/*
      <section id="faq">
        <FAQ />
      </section>
      */}
        {/* Activities Section 
      <section id="activities">
        <Activities />
      </section>
      */}
        <section id="about">
          <AboutUs />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
      <Footer />

      {/* Google Ads Testing Component - Remove in production */}
      {/*process.env.NODE_ENV === 'development' && <GoogleAdsTest />*/}
    </>
  );
};

const App: React.FC = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/noteikumi" element={<TermsAndConditions />} />
          <Route path="/whatsapp" element={<WhatsAppQR />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
